import React, { useState } from "react";
import PortalOverlay from "../../../../Shared/portal-overlay/portalOverlay";
// Styles
import Styles from "../../../../Shared/popup.module.scss";

// Components
import Button from "../../../../Shared/button/button";

// Styles
import {
  dangerButtonStyle,
  cancelButtonStyle,
  cancelButtonHoverStyle,
  dangerButtonHoverStyle,
} from "../../../../Shared/buttonStyles";
import { DANGER } from "../../../../Shared/colors";

// Functions
import { callApi } from "../../../../api/fetch";
import { unwrapListData } from "../../../../utils/dashboardMappers";

// Constants
import { MEDIUM } from "../../../../Shared/buttonSize";

function DeleteApiKey({ onSubmit, onCancel, appId, keyName }: any) {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  function handleCancel(event: any) {
    event.preventDefault();
    onCancel();
    return;
  }

  async function handleDeleteKey() {
    if (loading) return;

    try {
      setLoading(true);
      const keysData = await callApi(
        `/keys?app_ids=${encodeURIComponent(appId)}`,
        { method: "GET" }
      );
      const keys = unwrapListData<Record<string, unknown>>(keysData, "keys");
      const key = keys.find(
        (item) => item.key_name === keyName
      );
      if (!key?.key_id) throw new Error("API key not found");
      await callApi(`/keys/${key.key_id}`, { method: "DELETE" });
      const refreshedKeysData = await callApi(
        `/keys?app_ids=${encodeURIComponent(appId)}`,
        { method: "GET" }
      );
      const refreshedKeys = unwrapListData<Record<string, unknown>>(
        refreshedKeysData,
        "keys"
      );

      setLoading(false);
      onSubmit(refreshedKeys);
    } catch (err) {
      setLoading(false);
      setError((err as Error).message);
    }
  }
  return (
    <PortalOverlay>
      <div
      className={`d-flex align-items-center justify-content-center ${Styles.overlay}`}
    >
      <div className={`p-4 ${Styles.popUpContent}`}>
        <div className="py-3">
          <p className={`mb-0 ${Styles.warningMessage} text-center`}>
            Are you sure you want to delete this key{" "}
          </p>
        </div>
        <div className="d-flex align-items-center py-3 justify-content-around">
          <div className="px-2">
            <Button
              hoveredStyle={cancelButtonHoverStyle}
              style={cancelButtonStyle}
              id="manage-apps-delete-api-key-cancel"
              onClick={handleCancel}
              size={MEDIUM}
            >
              Cancel
            </Button>
          </div>
          <div className="px-2">
            <Button
              hoveredStyle={dangerButtonHoverStyle}
              style={dangerButtonStyle}
              id="manage-apps-delete-api-key-delete"
              onClick={handleDeleteKey}
              isLoading={loading}
              size={MEDIUM}
            >
              Delete
            </Button>
          </div>
        </div>
        {error && (
          <div className="py-2">
            <p
              className="mb-0 text-center"
              style={{ color: DANGER, fontSize: "12px" }}
            >
              {error}
            </p>
          </div>
        )}
      </div>
    </div></PortalOverlay>
  );
}

export default DeleteApiKey;
